import 'slick-carousel';

export default {
  init() {
    // JavaScript to be fired on the home page
    $('[data-session-trigger]').on('click', function(e) {
      e.preventDefault();
      $('.event-session').hide();
      $('.event-session[data-session="' + $(this).data('session-trigger') + '"]').show();
    });
    $('.btn-register-eventbrite').on('click', function(e) {
      e.preventDefault();
      $('.eventbrite-modal').addClass('active');
    });
    $('.eventbrite-close').on('click', function(e) {
      e.preventDefault();
      $('.eventbrite-modal').removeClass('active');
    });

    $('.slick.marquee').slick({
      speed: 5000,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: 'linear',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      infinite: true,
      initialSlide: 1,
      arrows: false,
      buttons: false,
      pauseOnHover: false,
      pauseOnFocus: false,
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleEvent.js